module.exports = __webpack_public_path__ + "media/images/fastweb-logo-for-white-bg-be35e2e7.svg";